module.exports = __webpack_public_path__ + "static/media/16.M-Cure 6-c.148d9b53.jpg";